import { toast } from 'sonner';

import type { TaskNotifyToastOptions, TaskUtils } from './types';

export function showToast(message: string, options?: TaskNotifyToastOptions): void {
  const data = options?.description ? { description: options.description } : undefined;

  switch (options?.variant) {
    case 'success':
      toast.success(message, data);
      break;
    case 'error':
      toast.error(message, data);
      break;
    case 'warning':
      toast.warning(message, data);
      break;
    case 'info':
      toast.info(message, data);
      break;
    default:
      toast(message, data);
  }
}

export const notifyUtils: TaskUtils['notify'] = {
  toast: (message, options) => showToast(message, options)
};
